var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    {
      staticClass: "table",
      class: [
        _vm.isLoading ? "is-loading" : "",
        _vm.hasStickyHeader ? "has-sticky-header" : "",
      ],
      style: `--sticky-header-top: ${_vm.stickyHeaderTop}`,
    },
    [
      _vm._t("colgroup"),
      _c(
        "thead",
        [
          _vm._t("header"),
          _vm.showHeader
            ? _c(
                "tr",
                {
                  class: {
                    [`height-${_vm.headerHeight}`]: _vm.headerHeight,
                    "header-no-border": _vm.headerHasNoBorder,
                  },
                },
                [
                  _vm.isTitleCheckable && _vm.titleCheckboxLocation === "front"
                    ? _c(
                        "th",
                        {
                          staticClass: "has-vertical-middle has-text-centered",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-curve p-smooth m-0 p-bigger",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isChecked,
                                    expression: "isChecked",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.isChecked)
                                    ? _vm._i(_vm.isChecked, null) > -1
                                    : _vm.isChecked,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isChecked,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isChecked = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isChecked = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isChecked = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._m(0),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.columns, function (column, index) {
                    return _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: column.isVisible,
                            expression: "column.isVisible",
                          },
                        ],
                        key: index,
                        staticClass: "has-vertical-middle",
                        class: [`has-text-${column.align}`],
                      },
                      [
                        column.sortable
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.sort(column)
                                  },
                                },
                              },
                              [
                                _vm._v(" " + _vm._s(column.title) + " "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.currentSortColumn === column.name,
                                        expression:
                                          "currentSortColumn === column.name",
                                      },
                                    ],
                                    staticClass: "icon is-small",
                                    class: { "is-desc": !_vm.isAsc },
                                  },
                                  [_c("i", { staticClass: "sort-icon" })]
                                ),
                              ]
                            )
                          : _c("span", [_vm._v(_vm._s(column.title))]),
                      ]
                    )
                  }),
                  _vm.isTitleCheckable && _vm.titleCheckboxLocation === "end"
                    ? _c("th", { staticClass: "has-vertical-middle" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-curve p-smooth m-0 p-bigger",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.isChecked,
                                  expression: "isChecked",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.isChecked)
                                  ? _vm._i(_vm.isChecked, null) > -1
                                  : _vm.isChecked,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.isChecked,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.isChecked = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.isChecked = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.isChecked = $$c
                                  }
                                },
                              },
                            }),
                            _vm._m(1),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.totalRows > 0 || _vm.showFooter
        ? _c(
            "tfoot",
            [
              _vm._t("footer"),
              _vm.showPagination
                ? _c("tr", [
                    _c(
                      "th",
                      {
                        attrs: {
                          colspan: _vm.isTitleCheckable
                            ? _vm.columns.length + 1
                            : _vm.columns.length,
                        },
                      },
                      [
                        _c("pagination", {
                          attrs: {
                            "current-page": _vm.pageIndex,
                            "total-rows": _vm.totalRows,
                            "page-size": _vm.pageSize,
                          },
                          on: { pageChanged: _vm.onPageChange },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.totalRows > 0 && _vm.draggable
        ? _vm._t("default")
        : _vm.totalRows > 0 && !_vm.draggable
        ? _c("tbody", [_vm._t("default")], 2)
        : !_vm.isLoading && !_vm.draggableEmpty
        ? _c("tbody", [
            _c("tr", [
              _c(
                "td",
                {
                  attrs: {
                    colspan: _vm.isTitleCheckable
                      ? _vm.columns.length + 1
                      : _vm.columns.length,
                  },
                },
                [_vm._t("empty")],
                2
              ),
            ]),
          ])
        : !_vm.isLoading && _vm.draggableEmpty
        ? _vm._t("empty")
        : _vm.isLoading
        ? _c("tbody", [
            _c("tr", [
              _c(
                "td",
                {
                  attrs: {
                    colspan: _vm.isTitleCheckable
                      ? _vm.columns.length + 1
                      : _vm.columns.length,
                  },
                },
                [_vm._m(2)]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
        _c(
          "span",
          { staticStyle: { opacity: "0" }, attrs: { icon: "icon is-large" } },
          [_c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-36px" })]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }